





























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button, Popup, Toast } from 'vant';
import { getVoteList } from '@/api/api';
import VoteButton from './VoteButton.vue';
import DetailModal from './DetailModal.vue';
import SuccessModal from './SuccessModal.vue';
import { isWeiXin, inAppAlertLogin } from '@/common/ts/common';
import Rule from './Rule.vue';
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
type Target = 'detail' | 'success';
@Component({
  components: {
    DetailModal,
    SuccessModal,
    VoteButton,
    Rule,
  },
})
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop() options!: any;
  @Prop() successStatus!: any;
  loading = false;
  finished = false;
  show: boolean = true;
  page = 1;
  id: any = [];
  getListData: any[] = [];
  result = [];
  SearchData = '';
  modalVisible = false;
  target: string = 'success';
  scrollTop = 0;
  modalInsufficient = false;
  activeVoteItemIndex = 0;
  voteResponseList: any = null;
  modalFull = false;
  voteShow = true;
  showVote: boolean = false;
  // @Watch('modalVisible')
  // onModalToggle(newVal: boolean) {
  //   if (newVal) {
  //     this.scrollTop =
  //       document.documentElement.scrollTop || document.body.scrollTop;
  //     document.body.classList.add('modal-open');
  //     document.body.style.top = -this.scrollTop + 'px';
  //   } else {
  //     document.body.classList.remove('modal-open');
  //     document.documentElement.scrollTop = this.scrollTop;
  //     document.body.scrollTop = this.scrollTop;
  //   }
  // }

  get currentActiveItemDetail() {
    if (this.getListData.length) {
      return this.getListData[this.activeVoteItemIndex];
    }
  }

  // 时间判断
  created() {
    if ((new Date() as any) / 1000 >= 1574092800) {
      this.voteShow = false;
    }
    const token = window.gettoken();
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid && isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    } else if (window.udid && (token === 'null' || !token)) {
      inAppAlertLogin();
    } else if (!isWeiXin() && !window.udid) {
      return Toast.fail('请在微信或者上游新闻APP中打开');
    }
  }
  // 初使加载
  onLoad() {
    setTimeout(() => {
      getVoteList({
        voteName: this.options.voteName,
        page: this.page,
      }).then((res: any) => this.fetchListData(res));
    });
  }
  fetchListData(res: any) {
    if (!res.data.length) {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  // 票数不足
  InsufficientVotes(e: Event) {
    if (this.id.length !== 10) {
      e.stopPropagation();
      this.modalInsufficient = true;
      setTimeout(() => {
        this.modalInsufficient = false;
      }, 2000);
    }
    setTimeout(() => {
      this.modalInsufficient = false;
    }, 2000);
  }
  onVoteSuccess(payload: any) {
    this.id = [];
    this.target = 'success';
    this.modalVisible = true;
    this.voteResponseList = payload;
  }
  votes(index: number) {
    if (this.id.includes(index)) {
      this.id.map((item: any, num: any) => {
        if (item === index) {
          this.id.splice(num, 1);
        }
      });
    } else {
      this.id.push(index);
    }
    this.$emit('selectNum', this.id);
  }
  toggleModal(target: Target, payload?: any) {
    this.$emit('closeGuide', false);
    this.target = target;
    console.log(target);
    this.modalVisible = !this.modalVisible;
    if (payload >= 0) {
      this.activeVoteItemIndex = payload;
    }
  }

  @Watch('successStatus', {
    immediate: true,
  })
  changeSsuccessStatus() {
    if (this.successStatus) {
      this.id = [];
    }
  }
}
